/**
 * Seed template identifiers
 *
 * Identifies the system-provided inspection templates that are seeded into a
 * channel when its inspection module is enabled. The template data itself lives
 * in the inspection domain (`domains-inspection`).
 *
 * This enum lives here, rather than alongside the seed data, so that Temporal
 * workflow code can reference it. Workflows are bundled for a sandboxed V8
 * isolate with no Node builtins, and importing the domain would pull its
 * Node-only dependencies (logging, dd-trace) into that bundle.
 */
export enum SeedTemplateKey {
  AbbreviatedBuilding = 'abbreviated_building',
  ComprehensiveOffice = 'comprehensive_office',
  IndustrialAbbreviated = 'industrial_abbreviated',
  IndustrialBuildingComprehensive = 'industrial_building_comprehensive',
}
